/**
 * ShopInformationList
 * --
 */
import { useState, useEffect, useMemo } from 'react';
import { Content, TabMenu } from 'components';
import { useGetUsers } from 'hooks/UserHooks';
import { Button, Input, Pagination, Flex } from 'antd';
import { useLocation } from 'react-router-dom';

/**----------------------------------------
 * [Component] 입점업체 목록: 사이드 컴포넌트
 * ----------------------------------------
 */
const UserList = ({
  users = [],
  selectedUser = null,
  fetch = true,
  onChange,
  query,
  // onLoaded,
  maxHeight,
}) => {
  const location = useLocation();
  const { user_phone: userPhone } = location.state || '';
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  let { data: UserList } = useGetUsers(query, {
    select: (res) => {
      const { status, data } = res;
      if (status !== 200) {
        return [];
      }
      return data;
    },
    initialData: [],
    refetchOnMount: false,
    enabled: fetch,
  });
  // 선택된 업체의 키
  // const [inputValue, setInputValue] = useState('');
  const [keyword, setKeyword] = useState('');
  // 선택된 업체의 키
  const [currentUser, setCurrentUser] = useState(null);
  const [usersList, setUsersList] = useState(null);
  const pageSize = 20;
  const [currentPage, setCurrentPage] = useState(1);

  const pagedUsers = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return usersList?.slice(start, start + pageSize);
  }, [usersList, currentPage]);

  const handleSearch = () => {
    let newData;
    if (fetch) {
      newData = UserList;
    } else {
      newData = users;
    }
    const filteredData = newData?.filter((item) => {
      if (
        keyword &&
        (item?.user_name.includes(keyword) ||
          item?.user_phone
            ?.replace(/-/g, '')
            ?.includes(keyword?.replace(/-/g, '')))
      ) {
        return true;
      } else if (!keyword) {
        return true;
      } else {
        return false;
      }
    });
    setUsersList(filteredData);
    setCurrentPage(1);
  };

  useEffect(() => {
    onChange(currentUser);
  }, [currentUser]);

  useEffect(() => {
    setCurrentUser(selectedUser);
  }, [selectedUser]);

  useEffect(() => {
    handleSearch();
  }, [users]);

  useEffect(() => {
    if (userPhone) {
      setKeyword(userPhone);
    }
    return () => {
      setKeyword('');
    };
  }, []);
  /* ===== RENDER ===== */
  return (
    <>
      <Content
        maxWidth={'100%'}
        minHeight={662}
        padding={0}
        className="boxShadow"
        backgroundColor="#fff"
      >
        {/* === === */}
        <Content
          maxWidth={'100%'}
          padding={10}
          style={{ borderBottom: '1px solid #EBEBEB' }}
        >
          <Flex>
            <Input
              placeholder="회원명 또는 번호(-없이)를 입력해주세요"
              allowClear
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
            <Button onClick={() => handleSearch()}>검색하기</Button>
          </Flex>
        </Content>

        {/* === === */}
        <Content
          maxWidth={'100%'}
          padding={5}
          className="custom-scroll"
          style={{
            height: '100%',
            ...(maxHeight && {
              maxHeight: typeof maxHeight === 'number' ? maxHeight : 800,
              overflowY: 'auto',
            }),
          }}
        >
          <TabMenu
            items={pagedUsers?.map((item) => ({
              ...item,
              key: item?.user_id,
              activeKey: item?.user_id,
              label: (
                <>
                  <p className="cursorOverOpacity">
                    {item?.user_name} (
                    {item?.user_phone?.replace(/\(\d+\)/, '')})
                    {item?.grade_name ? (
                      <>
                        <p>({item?.grade_name})</p>
                      </>
                    ) : null}
                  </p>
                </>
              ),
            }))}
            style={{
              maxHeight: '100%', // 컨테이너 크기 제한 유지
              overflowY: 'auto', // 내용이 넘치면 스크롤
            }}
            activeKey={currentUser}
            collapseKey={currentUser}
            onChange={({ key }) => setCurrentUser(key)}
          />
          <Pagination
            style={{
              width: '100%', // 전체 너비를 차지
              display: 'flex', // 중앙 정렬을 위해 flex
              justifyContent: 'center', // 중앙 정렬
            }}
            current={currentPage}
            pageSize={pageSize}
            total={usersList?.length}
            onChange={(page) => setCurrentPage(page)}
            simple
            showSizeChanger={false}
          />
        </Content>
      </Content>
    </>
  );
};

UserList.defaultProps = {
  defaultId: null,
  query: null,
  maxHeight: null,
  users: [],
  selectedUser: null,
  fetch: true,
  onChange: () => {},
  onLoaded: () => {},
};
export default UserList;
